import React from "react";
import cloud_migration_about from "../../assets/cloud_migration/cloud_mig_about.png";

const CloudConsultationInfo = () => {
  return (
    <div id="about">
      <div className="flex p-5 flex-col sm:flex-row">
        <div className="w-full sm:w-[40%]">
          <img src={cloud_migration_about} />
        </div>
        <div className="w-full sm:w-[60%]">
          <p className="font-notosans mt-5 mb-10">
            Unlock the full potential of cloud technology with Flint Infotech's
            Strategic Cloud Consultation services. Our expert consultants are
            here to guide you through the intricate landscape of cloud
            solutions, providing tailored strategies that align with your
            business goals.
          </p>
          <p className="font-notosans mt-5 mb-10">
            In our collaborative consultation sessions, we delve deep into your
            unique requirements, offering insights on the most suitable cloud
            platforms, migration strategies, and optimization approaches.
            Whether you're initiating your cloud journey or seeking to enhance
            existing cloud capabilities, our seasoned consultants bring a wealth
            of expertise to navigate complexities and ensure a roadmap that
            maximizes efficiency and ROI.
          </p>

          <p className="font-notosans mt-5 mb-10">
            At Flint Infotech, we don't just provide advice; we craft customized
            solutions that propel your business forward. Embrace innovation,
            scalability, and security with confidence. Schedule a consultation
            today and let us empower your digital transformation in the cloud
            era.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CloudConsultationInfo;
